<template>
    <el-container>
        <el-header class="headerLogin">
            <div class="divHeaderLogin"><label class="lblLogin">Demo Reset</label></div>
        </el-header>
        <el-main class="formContainer">
            <el-table
                :data="users"
                empty-text="Loading..."
                style="width: 100%">
                <el-table-column
                    prop="name"
                    label=""
                >
                </el-table-column>
                <el-table-column
                    prop="email"
                    label="">
                </el-table-column>
                <el-table-column
                label="Operations" width="75">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="info"
                    @click="handleEdit(scope.$index, scope.row)">Reset</el-button>
                </template>
                </el-table-column>
                </el-table>
        </el-main>
    </el-container>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    created (){
        this.$store.dispatch('demoreset/getUsers');
    },
    watch: {
        status: function(newStatus, oldStatus) {
            if (newStatus) {
                this.open3();
                this.$store.commit('demoreset/setStatus', false);
            }
        },
    },
    methods: {
      handleEdit(index, row) {
        this.$store.dispatch('demoreset/resetUsers', row);
      },
      open3() {
        this.$notify({
          title: 'Success',
          message: 'This is a success message',
          type: 'success',
        });
      },
    },
    computed: {
        ...mapGetters({
            users : 'demoreset/users',
            status: 'demoreset/status',
        }),
    },
  };
</script>
<style>
  .divHeaderLogin {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .headerLogin {
    height: 80px !important;
    background: #6C30CC;
    box-shadow: 0px 0px 6px 6px rgba(0, 0, 0, 0.16);
  }
  .lblLogin {
      color: #FFFFFF;
      font-weight: bold;
  }
  .formContainer {
    text-align: center;
    justify-content: center;
    display: flex;
    margin-top: 0px;
  }
  .el-table thead {
      display:none !important;
  }
</style>